<template>
  <div class="options">
    <v-option>
      <template slot="h">
        What are the languages?
      </template>
      <p>
        None of our offered citizenship programs requires specific knowledge of particular language and we are here to help you to apply for and to obtain your selected citizenship. If you are planning to move to the country, which citizenship you have selected, it would be helpful for you to have a basic knowledge of English language, as it is the most popular language in all countries where we are offering citizenship.
      </p>
    </v-option>
    <v-option>
      <template slot="h">
        What is your ideal timeframe?
      </template>
      <p>
        The citizenship obtaining timeframe varies from 8 weeks to 12 months, but usual citizenship obtaining timeframe is around 4-5 months.  The fastest option is obtaining Vanuatu citizenship it takes only around 8 weeks, but the longest one is the Maltese citizenship, due to its complexity and prestige.
      </p>
    </v-option>
    <v-option>
      <template slot="h">
        What is your reason for obtaining second passport?
      </template>
      <p>
        In case you are planning to use the second citizenship for traveling, the best option for you would be the Maltese citizenship, as Malta is the EU Member State meaning that citizens of Malta as holders of Maltese passports benefit from 181 visa-free countries and territories. But we would like to pay your attention on the fact that obtaining the Maltese citizenship is quite complicated, expensive, long- term but very prestige project. The best citizenship from Caribbean region is Dominican. The holders of Dominica passport benefit from 143 visa free countries and territories, including the possibility to apply for USA E2 Visa. The E2 Treaty Investor visa allows the investor to reside and work in the US to direct and develop the business. And, please, do not forget about Vanuatu citizenship.  The Vanuatu citizenship could be obtained after 6-8 weeks and citizenship of Vanuatu allows you visa-free traveling to 129 countries and territories (including UK, EU, Singapore and Russian Federation).
      </p>
    </v-option>
    <v-option>
      <template slot="h">
        What is your preferred investment type?
      </template>
      <p>
        The two most popular types of obtaining citizenship are through donation to the special fund or through investment in real estate. If we are talking about the required minimum money amount in case of the investment in real estate, investment amount should be bigger. But the investment in real estate make you an owner of a real estate, that you will be able to use for necessities of your family or for leasing. So- it all depends on the investment amount, that you are ready to invest for the citizenship and on how you are planning to use your obtained citizenship.
        Please note that there are several countries where you can obtain the citizenship only by donating to the special fund- for example, Vanuatu. There are also some citizenships that could not be obtained only by donating to the special fund- for example, Malta and Cyprus.
      </p>
    </v-option>
    <v-option>
      <template slot="h">
        Your family
      </template>
      <p>
        Usually the price for citizenship, in case of the investment in special donation fund, varies from the amount of family members. The general principle is that the more family members there are, the higher is the price for application and obtaining of citizenship.  The only exclusion from this principle is the case of donation in specific fund in Antigua and Barbuda, where the price for citizenship will remain the same for up to 5 family members.
        In case of investment in real estate- citizenship fee will not change and will be the same up to 5 family members. The only change will be in the due diligence fee that will depend from the exact amount of the family members, who are applying for citizenship.
      </p>
    </v-option>
    <v-option>
      <template slot="h">
        What is your budget and overall?
      </template>
      <p>
        The average total price for the citizenship including the donation in the specific fund for Caribbean region and Vanuatu is around USD 170 000. The cheapest option for the citizenship program via donation is in Dominica, which is around USD 143 000 for one person (including donation).  In case of additional family member (including wife) the price will increase.  The cheapest option via investment in real estate is also the citizenship program in Dominica, which is around USD 267 000 for one person (including investment amount in real estate). Malta and Cyprus offer the citizenship program of different classes; therefore, the price will start from more than EUR 1 000 000 (including required investments) Each case is verified separately.
      </p>
    </v-option>
  </div>
</template>

<script>
import VOption from './option';

export default {
  components: { VOption },
};
</script>

<style lang="scss" scoped>
.options {
  box-shadow: -2px 10px 40px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  color: #131e43;
}
</style>